import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateAirline } from "../../api/apiAirlines";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateAirline = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: updateAirlineAction, isPending } = useMutation({
        mutationFn: ({ id, data }) => updateAirline(id, data),
        onSuccess: (res) => {
            const message = res?.message || "Airline updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airlines"] });
            navigate("/airlines");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update airline");
        },
    });

    return { updateAirline: updateAirlineAction, isPending };
};

export default useUpdateAirline;
